import { errorConstants } from './error.constants';
import * as Sentry from "@sentry/react";

function setError(name, isActive) {
    return dispatch => {
        if (isActive) {
            Sentry.captureMessage(`Error: ${name}`);
        }
        dispatch({
            type: errorConstants.SET_ERROR,
            payload: { name, isActive }
        });
    };
}

function setAPIError(name, isActive, isApiError, statusCode = null) {
    return dispatch => {
        if (isActive && isApiError) {
            Sentry.captureException(new Error(`API Error: ${name}`));
        }
        dispatch({
            type: errorConstants.SET_ERROR_API,
            payload: { name, isActive, isApiError, statusCode }
        });
    };
}

export { setError, setAPIError }
